export const GlobalEtfLogo = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="assets/etfs/global">
        <path
          id="Path"
          d="M21.375 5.625C21.8827 5.641 22.2603 5.66453 22.5076 5.69558C26.5841 6.20744 29.8124 9.44584 30.3087 13.5272C30.3379 13.767 30.36 14.133 30.375 14.625C29.8595 14.625 29.4729 14.625 29.2152 14.625C27.4729 14.625 24.8595 14.625 21.375 14.625C21.375 11.1229 21.375 8.49637 21.375 6.74533C21.375 6.49637 21.375 6.12292 21.375 5.625Z"
          fill="#24458A"
        />
        <path
          id="Combined Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.5652 16.4348H19.5652V7.43475H18C12.165 7.43475 7.43478 12.165 7.43478 18C7.43478 23.835 12.165 28.5652 18 28.5652C23.835 28.5652 28.5652 23.835 28.5652 18V16.4348ZM18 27C13.0294 27 9 22.9705 9 18C9 13.0294 13.0294 8.99997 18 8.99997V18H27C27 22.9705 22.9706 27 18 27Z"
          fill="#24458A"
        />
      </g>
    </svg>
  );
};
